import _ from 'lodash';

export default {
  set(state, { path, payload }) {
    _.set(state, path, payload);
  },
}
